export const isGeocoderEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_NEW_ADDRESS_VALIDATION_ABACUS') || experimentUtil.isTestVariant('ULX_ADDRESS_VALIDATION');

export const isUnitCheckEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_NEW_ADDRESS_VALIDATION_ABACUS') || experimentUtil.isTestVariant('ULX_ADDRESSV2_VR');

export const isAemEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_VR_AEM_ENABLED_ABACUS');

export const isAuthFlagDisabled = experimentUtil => experimentUtil.isTestVariant('ULX_AUTH_BYPASS_ABACUS');

export const isDoubledValidationEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_DEDUPLICATION_EMAIL');

export const isPhoneSecureListFTEnabled = experimentUtil => experimentUtil.isTestVariant('UFO_2FA_SECURITY_FT');

export const isClPropertyNameInstructions = experimentUtil => experimentUtil.isTestVariant('PXO_PROPERTY_NAME_INSTRUCTIONS');

export const isContentMessagingUpdatesEnabled = experimentUtil => experimentUtil.isTestVariant('PXO_CONTENT_MESSAGING_UPDATES');

export const isClAddressImprovements = experimentUtil => experimentUtil.isTestVariant('PXO_ADDRESS_IMPROVEMENTS_CL') || experimentUtil.isTestVariant('ULX_ADDRESSV2') || experimentUtil.isTestVariant('ULX_ADDRESSV2_VR');

export const isLinkCollectionEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_LINK_COLLECTION');

export const usesGeoFeed = experimentUtil => experimentUtil.isTestVariant('PXO_GEOFEEDS');

export const getVacasaVariant = experimentUtil => experimentUtil.getExperimentDataByName('ULX_PM_VACASA')?.value ?? 0;

export const isVideoTestimonialsActive = experimentUtil => experimentUtil.isTestVariant('ULX_VIDEO_TESTIMONIAL') || experimentUtil.isTestVariant('ULX_Classification_Video_Testimonial');

export const howItWorksActive = experimentUtil => experimentUtil.isTestVariant('ULX_HOW_IT_WORKS_VR') || experimentUtil.isTestVariant('ULX_HOW_IT_WORKS_CL');

export const isPendoEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_PENDO_INTEGRATION');

export const isTcEnabledULX = experimentUtil => experimentUtil.isTestVariant('TC_SUPPLY_VRBO');

export const isValuePropBannerActive = experimentUtil => experimentUtil.isTestVariant('ULX_VALUE_PROP_BANNER') || experimentUtil.isTestVariant('ULX_VALUE_PROP_BANNER_CL');

export const isRebrandingActive = experimentUtil => experimentUtil.isTestVariant('ULX_REBRANDING_VRBO_FF') || experimentUtil.isTestVariant('ULX_REBRANDING_CL');

export const isUPLIntegrated = experimentUtil => experimentUtil.isTestVariant('ULX_UPL_INTEGRATION');

export const isCLLinkCollection = experimentUtil => experimentUtil.isTestVariant('ULX_CL_LINK_COLLECTION');

export const getCLStickBannerVariant = experimentUtil => experimentUtil.getExperimentDataByName('ULX_CL_STICKY_ABC')?.value ?? 0;

export const isEsXlLocaleEnabled = experimentUtil => experimentUtil.isTestVariant('ULX_ES_LX_LOCALE_CL');
